import { Modal } from '@components/Customized';
import { formatDate } from '@utils/formatter';

interface DeliveryExtendReasonModalProps {
  isOpen: boolean;
  onClose: () => void;
  extendReason: string;
  registerExpectedDate: string;
}

const DeliveryExtendReasonModal = ({
  isOpen,
  onClose,
  extendReason,
  registerExpectedDate
}: DeliveryExtendReasonModalProps) => {
  const formatedDate = formatDate(registerExpectedDate, 'YYYY.MM.DD');

  return (
    <Modal open={isOpen} onClose={onClose}>
      <Modal.Title>구매확정일 연장 사유</Modal.Title>
      <Modal.CloseButton onClose={onClose} />

      <Modal.ContentSection>
        <Modal.Text variant="body2" color="textSecondary" gutterBottoms={16}>
          {formatedDate}까지 구매확정일 연장
        </Modal.Text>
        <Modal.Text
          variant="body1"
          color="textPrimary"
          style={{
            wordBreak: 'break-all'
          }}
        >
          {extendReason}
        </Modal.Text>
      </Modal.ContentSection>
    </Modal>
  );
};

export default DeliveryExtendReasonModal;
